import { Injectable } from '@angular/core';


@Injectable()
export class JwtService {

  getToken(): string {
    return window.localStorage['jwtToken'];
  }
  getworkflow(): any {
    return window.localStorage['Puser'];
  }
  getclientlogo(): any {
    return window.localStorage['logopath'];
  }
  getmail(): any {
    return window.localStorage['mail'];
  }
  saveToken(token: string) {
    window.localStorage['jwtToken'] = token;
  }
  savemail(email: string) {
    window.localStorage['mail'] = email;
  }
  
  saveclientlogo(logopath: string) {
    
    window.localStorage['logopath'] = logopath;
  }
  ipclientlogo(logopath: string) {
    
    window.localStorage['logopath'] = logopath;
  }
  message(count: string) {
    
    window.localStorage['count'] = count;
  }
  saveworkflow(Puser:any){
    window.localStorage['Puser'] = Puser;
  }
  pwdupdate(pwd:{}){
    window.localStorage['pwd'] = pwd;
  }
  patpwd(patpwd:{}){
    window.localStorage['patpwd'] = patpwd;
  }
  destroyToken() {
    window.localStorage.removeItem('jwtToken');
  }
  destroyworkflow(){
    window.localStorage.removeItem('Puser');
  }
  destroymail(){
    window.localStorage.removeItem('mail');
  }
  

}
